import { apiFetch } from "./client";

export interface TenantGroup {
  id: string;
  companyId: string;
  name: string;
  description: string | null;
  source: "local" | "entra";
  externalId: string | null;
  lastSyncedAt: string | null;
  memberCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface TenantGroupMember {
  id: string;
  groupId: string;
  tenantUserId: string;
  createdAt: string;
  userEmail: string;
  userDisplayName: string | null;
  userRole: string;
}

/** One agent given to one group (from the agent's Access tab). */
export interface GroupAgentGrant {
  groupId: string;
  agentId: string;
  agentName: string;
}

export const tenantGroupsApi = {
  list: (companyId: string) =>
    apiFetch<TenantGroup[]>(`/companies/${companyId}/groups`),

  /** Every group's agents in one call. Tenant admin only. */
  agentAccess: (companyId: string) =>
    apiFetch<GroupAgentGrant[]>(`/companies/${companyId}/groups/agent-access`),

  create: (companyId: string, data: { name: string; description?: string }) =>
    apiFetch<TenantGroup>(`/companies/${companyId}/groups`, {
      method: "POST",
      body: JSON.stringify(data),
    }),

  update: (companyId: string, groupId: string, data: { name?: string; description?: string | null }) =>
    apiFetch<TenantGroup>(`/companies/${companyId}/groups/${groupId}`, {
      method: "PATCH",
      body: JSON.stringify(data),
    }),

  delete: (companyId: string, groupId: string) =>
    apiFetch<void>(`/companies/${companyId}/groups/${groupId}`, {
      method: "DELETE",
    }),

  listMembers: (companyId: string, groupId: string) =>
    apiFetch<TenantGroupMember[]>(`/companies/${companyId}/groups/${groupId}/members`),

  addMembers: (companyId: string, groupId: string, tenantUserIds: string[]) =>
    apiFetch<TenantGroupMember[]>(`/companies/${companyId}/groups/${groupId}/members`, {
      method: "POST",
      body: JSON.stringify({ tenantUserIds }),
    }),

  removeMember: (companyId: string, groupId: string, memberId: string) =>
    apiFetch<void>(`/companies/${companyId}/groups/${groupId}/members/${memberId}`, {
      method: "DELETE",
    }),
};
